const CloudOutlined = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="17"
    height="12"
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.02344 11.1504C2.15948 11.1504 0.648438 9.63935 0.648438 7.77539C0.648438 6.01771 1.99207 4.57386 3.70824 4.41492C4.0593 2.27949 5.91362 0.650391 8.14844 0.650391C10.3833 0.650391 12.2376 2.27949 12.5886 4.41492C14.3048 4.57386 15.6484 6.01771 15.6484 7.77539C15.6484 9.63935 14.1374 11.1504 12.2734 11.1504C8.98106 11.1504 6.90591 11.1504 4.02344 11.1504Z"
      stroke="#A4A7AE"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CloudOutlined;
